import React from "react";
import Education from "../../components/Education";
import Experience from "../../components/Experiences";
import ProjectsSection from "../../components/Projects";
import Skill from "../../components/Skills";

const Resume = () => {
  return (
    <main>
      <div className="resume">
        <h2>EXPERIENCES</h2>
        <Experience />
        <h2>EDUCATIONS</h2>
        <Education />
        <h2>PROJECTS</h2>
        <ProjectsSection />
        <h2>SKILLS</h2>
        <Skill />
        {/* <h2>SERVICES</h2> */}
      </div>
    </main>
  );
};

export default Resume;
